import * as React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom-v5-compat';

import ByStudent from './by_student'
import BySkill from './by_skill'

import { ALL_PRACTICE, NO_CLASSROOM, renderNoClassroomEmptyState, } from '../../shared/shared'
import { ClassroomInterface, SkillCategoryInterface, StudentPerformanceData, SkillPerformanceData, SkillPracticeRecommendation } from '../interfaces';
import { useReportPremiumContext } from '../../shared/report_premium_context';
import {
  Spinner,
} from '../../../../../Shared/index';

interface SmartGroupsProps {
  classroom: ClassroomInterface;
  filteredSkillCategories: SkillCategoryInterface[];
  filteredSkillSubCategories: SkillCategoryInterface[];
  handleAssignTargetedPracticeClick: (skillId: number, studentIds: number[], smartGroup?: string) => void;
  includeELL: boolean;
  momentumScoreGoal: number;
  onSkillCategoryClick: (skillCategoryId: number) => void;
  practiceScope: string;
  renderHeader: (title: string) => React.ReactNode;
  renderNeedsVerificationEmptyState: () => React.ReactNode;
  renderUpgradeEmptyState: () => React.ReactNode;
  renderVerificationBanner: () => React.ReactNode;
  selectedSkillCategoryId: any;
  selectedSkillSubCategoryId: any;
  selectedStudentId: any;
  skillData: {[key: string]: SkillPerformanceData[]};
  skillDataKey: string;
  skillPracticeRecommendations: SkillPracticeRecommendation[];
  studentData: {[key: string]: StudentPerformanceData[]};
  studentDataKey: string;
  userNeedsVerification: boolean;
}

const SmartGroups: React.FC<SmartGroupsProps> = ({
  classroom,
  filteredSkillCategories,
  filteredSkillSubCategories,
  handleAssignTargetedPracticeClick,
  includeELL,
  momentumScoreGoal,
  onSkillCategoryClick,
  practiceScope,
  renderHeader,
  renderNeedsVerificationEmptyState,
  renderUpgradeEmptyState,
  renderVerificationBanner,
  selectedSkillCategoryId,
  selectedSkillSubCategoryId,
  selectedStudentId,
  skillData,
  skillDataKey,
  skillPracticeRecommendations,
  studentData,
  studentDataKey,
  userNeedsVerification,
}) => {
  const { hasSchoolOrDistrictPremium } = useReportPremiumContext();
  const location = useLocation();

  const byStudent = location.pathname.includes('by_student');

  const selectedSkillCategory = filteredSkillCategories.find(skillCategory => skillCategory.id === selectedSkillCategoryId)
  const selectedSkillSubCategory = filteredSkillSubCategories.find(skillSubCategory => skillSubCategory.id === selectedSkillSubCategoryId)

  const sharedProps = {
    classroom,
    handleAssignTargetedPracticeClick,
    includeELL,
    momentumScoreGoal,
    onSkillCategoryClick,
    practiceScope,
    selectedSkillCategory,
  }

  const routes = (
    <Routes>
      <Route
        element={
          <ByStudent
            {...sharedProps}
            data={studentData[studentDataKey]}
            selectedSkillSubCategory={selectedSkillSubCategory} 
          />
        }
        path="by_student"
      />
      <Route
        element={
          <BySkill
            {...sharedProps}
            data={skillData[skillDataKey]}
            skillPracticeRecommendations={skillPracticeRecommendations}
            studentId={selectedStudentId}
          />
        }
        path="by_skill"
      />
    </Routes>
  )

  if (!classroom || (byStudent && !selectedSkillCategory)) { return <Spinner /> }

  function renderContent() {
    if (!hasSchoolOrDistrictPremium && practiceScope === ALL_PRACTICE) {
      return renderUpgradeEmptyState()
    }
    
    if (userNeedsVerification && practiceScope === ALL_PRACTICE) {
      return renderNeedsVerificationEmptyState()
    }

    if (classroom.id === NO_CLASSROOM.id) {
      return renderNoClassroomEmptyState()
    }

    return routes
  }

  return (
    <main className="smart-groups">
      {renderHeader('Smart Groups')}
      {renderVerificationBanner()}
      <div className="smart-groups-content">
        {renderContent()}
      </div>
    </main>
  );
};

export default SmartGroups;
